module.exports = __webpack_public_path__ + "img/0-02-0a-7077b37dfdcfa24f186c501220cd53d6d8d40a1049460291cf703fa44fb8026a_7fdbfe32.838e37ef.jpg";